import React from "react";
import {
  Checkbox as UnstyledCheckbox,
  ListItem as UnstyledListItem,
} from "@material-ui/core";
import Field from "../../interfaces/Field";
import FieldSelectionMap from "../../interfaces/FieldSelectionMap";
import styled from "styled-components";

const ListItem = styled(UnstyledListItem)`
  && {
    &:hover {
      background: transparent;
    }
  }
`;

const Label = styled.label`
  && {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    white-space: break-spaces;
    font-size: 16px;
  }
`;

const Checkbox = styled(UnstyledCheckbox)`
  && {
    width: 23px;
    height: 23px;
    margin-right: 6px;
  }
`;

interface FieldOptionProps {
  field: Field;
  fieldSelectionMap: FieldSelectionMap;
  setFieldSelectionMap: (map: FieldSelectionMap) => void;
}

const FieldOption = ({
  field,
  fieldSelectionMap,
  setFieldSelectionMap,
}: FieldOptionProps) => {
  const toogleField = () => {
    const newMap = Object.assign({}, fieldSelectionMap);
    newMap[field.fieldId] = !newMap[field.fieldId];
    setFieldSelectionMap(newMap);
  };

  return (
    <ListItem>
      <Label>
        <Checkbox
          color="primary"
          checked={fieldSelectionMap[field.fieldId]}
          onChange={toogleField}
        />
        <span>{field.displayName}</span>
      </Label>
    </ListItem>
  );
};

export default FieldOption;
